import { callApi } from "../../utils/common.utils";

export const fetchLoginData = async (userName: string, passWord: string) => {
  const payLoad = {
    username: userName,
    password: passWord,
  };
  return callApi("checkUserLogin", payLoad, "getData");
};

export const forgotPassword = async (userName: string, url: string) => {
  const payLoad = {
    username: userName,
    url: url,
  };
  return callApi("forgotpassword", payLoad, "getData");
};
